import axios from "../../../util/axios";

export default {
    // 查询
    queryList: (searchInfo) => axios.get({url: `/order/product/unit/queryList`, data: searchInfo}),
    // 保存提交
    saveSubmit: (unitData) => axios.post({url: `/order/product/unit/saveSubmit`, data: unitData}),
    // 删除
    deleteRow: (id) => axios.del({url: `/order/product/unit/delete`,data:{id}}),
}